import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'tt-divider',
  template: '',
  styleUrls: ['./divider.component.scss'],
})
export class DividerComponent {}
